import { isLocalRuntimeHost } from './runtimeHost';

const PERSONNEL_TEST_PROFILES_KEY_PREFIX = 'mozzoapp:local-personnel-test-profiles:v1';
const PERSONNEL_TEST_ACTIVE_PROFILE_KEY = 'mozzoapp:local-personnel-test-active:v1';

const getProfilesStorageKey = (companyId) =>
  `${PERSONNEL_TEST_PROFILES_KEY_PREFIX}:${companyId || 'local-company'}`;

const readJson = (key, fallback) => {
  if (typeof window === 'undefined') {
    return fallback;
  }

  try {
    const value = JSON.parse(window.localStorage.getItem(key) || 'null');
    return value ?? fallback;
  } catch (error) {
    console.warn('No pudimos leer el banco local de Personal:', error);
    return fallback;
  }
};

const writeJson = (key, value) => {
  if (typeof window === 'undefined') {
    return;
  }

  window.localStorage.setItem(key, JSON.stringify(value));
};

export const isLocalPersonnelTestHarnessEnabled = () =>
  process.env.NODE_ENV === 'development' && isLocalRuntimeHost();

export const listLocalPersonnelTestProfiles = (companyId) => {
  if (!isLocalPersonnelTestHarnessEnabled()) {
    return [];
  }

  const profiles = readJson(getProfilesStorageKey(companyId), []);
  return Array.isArray(profiles) ? profiles : [];
};

export const saveLocalPersonnelTestProfile = (companyId, profile) => {
  if (!isLocalPersonnelTestHarnessEnabled()) {
    throw new Error('El banco de pruebas de Personal solo esta disponible en localhost.');
  }

  const normalizedProfile = {
    id:
      profile?.id ||
      (typeof window !== 'undefined' ? window.crypto?.randomUUID?.() : '') ||
      `local-personnel-${Date.now()}`,
    fullName: String(profile?.fullName || '').trim(),
    email: String(profile?.email || '').trim().toLowerCase(),
    roleKey: String(profile?.roleKey || 'mozo').trim(),
    branchId: String(profile?.branchId || '').trim(),
    branchName: String(profile?.branchName || '').trim(),
    permissions:
      profile?.permissions && typeof profile.permissions === 'object'
        ? { ...profile.permissions }
        : {},
    createdAt: profile?.createdAt || new Date().toISOString(),
  };

  const currentProfiles = listLocalPersonnelTestProfiles(companyId);
  const nextProfiles = [
    normalizedProfile,
    ...currentProfiles.filter((currentProfile) => currentProfile.id !== normalizedProfile.id),
  ];

  writeJson(getProfilesStorageKey(companyId), nextProfiles);
  return normalizedProfile;
};

export const removeLocalPersonnelTestProfile = (companyId, profileId) => {
  if (!isLocalPersonnelTestHarnessEnabled()) {
    return [];
  }

  const nextProfiles = listLocalPersonnelTestProfiles(companyId).filter(
    (profile) => profile.id !== profileId
  );
  writeJson(getProfilesStorageKey(companyId), nextProfiles);
  return nextProfiles;
};

export const readActiveLocalPersonnelTestProfile = () => {
  if (!isLocalPersonnelTestHarnessEnabled()) {
    return null;
  }

  const profile = readJson(PERSONNEL_TEST_ACTIVE_PROFILE_KEY, null);
  return profile && typeof profile === 'object' ? profile : null;
};

export const persistActiveLocalPersonnelTestProfile = (profile) => {
  if (!isLocalPersonnelTestHarnessEnabled()) {
    return;
  }

  writeJson(PERSONNEL_TEST_ACTIVE_PROFILE_KEY, profile);
};

export const clearActiveLocalPersonnelTestProfile = () => {
  if (typeof window !== 'undefined') {
    window.localStorage.removeItem(PERSONNEL_TEST_ACTIVE_PROFILE_KEY);
  }
};
